import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import {
  columnDescription,
  columnName,
  columnMultiSelect,
  columnPublisher,
  columnCreatedOn,
  columnUpdatedOn,
  columnTools,
  columnVisibility,
  columnStatus,
} from '@/constants/fields';
import { sortingFilters } from '@/constants/states';
import DatasetsTableColumnsWrapper from '@/datasets/components/DatasetsTableColumnsWrapper';
import { toggleCollectionDatasetColumnOrderBy, toggleCollectionDatasetsSelected } from '../actions';

const CollectionDatasetsTableColumns = ({
  category,
  code,
  items,
  onCheckBoxClick,
  onOrderByColumn,
  orderBy,
  singleSorting,
  columns = [
    columnMultiSelect,
    columnName,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnStatus,
    columnVisibility,
    columnPublisher,
    columnTools,
  ],
}) => (
  <DatasetsTableColumnsWrapper
    category={category}
    columns={columns}
    items={items}
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, code, selected)}
    onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, code, orderByColumn)}
    orderBy={orderBy}
    singleSorting={singleSorting}
  />
);

const mapStateToProps = ({
  collectionDatasets: { collectionDatasets },
}, { category, code }) => {
  const { orderBy, singleSorting } = findResult(collectionDatasets, category, code) || sortingFilters();
  return ({ orderBy, singleSorting });
};

const mapDispatchToProps = {
  onCheckBoxClick: toggleCollectionDatasetsSelected,
  onOrderByColumn: toggleCollectionDatasetColumnOrderBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetsTableColumns);
